import React, { useEffect } from 'react'
import { useLazyQuery } from '@apollo/client'
import { Paragraph, Separator, H6 } from '@fs/zion-ui'
import queries from '../../../../queries'
import { useGroupData } from '../../../../hooks'

import transl from './ReprocessFolder.transl'

export default function ReprocessChangeHistory({ requested, duplicateRequest }) {
  const [doReprocessSearch, { data }] = useLazyQuery(queries.reprocessData())

  const {
    group: { imageReprocessing = [], parentGroupId = '' },
  } = useGroupData()

  useEffect(() => {
    if (parentGroupId) {
      doReprocessSearch({ variables: { groupIdOrArkId: parentGroupId } })
    }
  }, [doReprocessSearch, parentGroupId])

  let changeHistory

  if (data?.group?.imageReprocessing) {
    changeHistory = data.group.imageReprocessing
  } else {
    changeHistory = imageReprocessing
  }

  function humanReadableDate(timestamp) {
    const dateObj = new Date(timestamp)
    const dateOptions = {
      month: 'long',
      day: 'numeric',
      year: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric',
    }

    const language = Navigator.language

    return dateObj.toLocaleString(language, dateOptions)
  }

  return (
    <>
      {requested || duplicateRequest || changeHistory.length !== 0 ? (
        <H6 size="H5" supplementary>
          {transl.changeHistoryTitle}
        </H6>
      ) : (
        ''
      )}
      {requested ? <Paragraph size="sm">{transl.changeHistoryInfo}</Paragraph> : ''}
      {duplicateRequest ? <Paragraph size="sm">{transl.changeHistoryDuplicate}</Paragraph> : ''}
      {changeHistory.map((reprocessed) => {
        if (reprocessed.action) {
          return (
            <React.Fragment key={reprocessed.date.fromTimestamp}>
              <Separator size="xxs" />
              <Paragraph size="sm">
                {reprocessed.action === 'COMPLETE' ? transl.changeHistoryReprocessed : transl.changeHistoryRequested}
                <br />
                {humanReadableDate(reprocessed.date.fromTimestamp)}
              </Paragraph>
            </React.Fragment>
          )
        }
        return ''
      })}
    </>
  )
}
